import React from 'react'
import { Box, Button, Flex, Table, Text } from '@workwhile/ui'
import { TableEmptyState } from 'components/Table/TableEmptyState'
import { useNotificationTasksContextValue } from '../../context/NotificationTasksProvider'
import { useSelectedColumns } from './ColumnsFilter/useSelectedColumns'
import { PayloadModal } from '../PayloadModal'

export const NotificationTasksTable = () => {
  const {
    state: {
      data,
      pageIndex,
      canGoPrevious,
      canGoNext,
      isFetching,
      modalPayload,
    },
    actions: { goToPreviousPage, goToNextPage, setModalPayload },
  } = useNotificationTasksContextValue()

  const columns = useSelectedColumns()
  const events = data.events
  const hasItems = events.length > 0

  return (
    <Box>
      {hasItems ? (
        <>
          <Text mb={2}>
            Showing {events.length.toLocaleString()} of{' '}
            {data.totalCount.toLocaleString()} result
            {data.totalCount === 1 ? '' : 's'}
          </Text>
          <Table columns={columns} data={events} enableSorting />
          {canGoPrevious || canGoNext ? (
            <Flex mt={3} alignItems="center" justifyContent="center">
              <Button
                variant="secondary"
                disabled={!canGoPrevious || isFetching}
                onClick={goToPreviousPage}
              >
                Previous
              </Button>
              <Text mx={3} color="lightText">
                Page {pageIndex}
              </Text>
              <Button
                variant="secondary"
                loading={isFetching}
                disabled={!canGoNext || isFetching}
                onClick={goToNextPage}
              >
                Next
              </Button>
            </Flex>
          ) : null}
        </>
      ) : (
        <TableEmptyState
          isFetching={isFetching}
          emptyMessage="No notification tasks matched your search."
        />
      )}
      {modalPayload !== null ? (
        <PayloadModal
          payload={modalPayload}
          onClose={() => setModalPayload(null)}
        />
      ) : null}
    </Box>
  )
}
